module.exports = __webpack_public_path__ + "img/84.4dca89be.jpg";